import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { UserWalletOperationTypeEnum } from 'app/models';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import { DeliveryOrderService } from 'app/services';

@Component({
    selector: 'driver-transaction-detail',
    templateUrl: './driver-transaction-detail.component.html',
    styleUrls: ['./driver-transaction-detail.component.scss',
        '../../../../../../styles/sidebar.scss']
})
export class DriverTransactionDetailComponent implements OnInit {
    public orderId: number = 0;
    public riderOrderDetail: any;
    public transaction: any;
    @Input()
    set _transaction(value: any) {
        this.transaction = { ...value };

        this.transaction.CreatedAtDate = Utils.utcToLocaleDateString(this.transaction.CreatedAt);
        this.transaction.CreatedAtTime = Utils.utcToLocaleTimeString(this.transaction.CreatedAt);
        this.transaction.BaseFare = `₱ ${this.transaction.BaseFare.toFixed(2).toLocaleString('en-US')}`;
        this.transaction.DistanceFare = `₱ ${this.transaction.DistanceFare.toFixed(2).toLocaleString('en-US')}`;
        this.transaction.SurgeCharges = `₱ ${this.transaction.SurgeCharges.toFixed(2).toLocaleString('en-US')}`;
        this.transaction.TollsAmount = `₱ ${this.transaction.TollsAmount.toFixed(2).toLocaleString('en-US')}`;
        this.transaction.RiderInsuranceAmount = `₱ ${this.transaction.RiderInsuranceAmount.toFixed(2).toLocaleString('en-US')}`;
        this.transaction.TipAmount = `₱ ${this.transaction.TipAmount.toFixed(2).toLocaleString('en-US')}`;
        this.transaction.TripDurationCharge = `₱ ${this.transaction.TripDurationCharge.toFixed(2).toLocaleString('en-US')}`;
        this.transaction.Amount = `₱ ${this.transaction.Amount.toFixed(2).toLocaleString('en-US')}`;
    }

    public isVisibleDriverTransactionDetail: boolean = false;
    @Input()
    set _isVisibleDriverTransactionDetail(value: boolean) {
        this.isVisibleDriverTransactionDetail = value;
    }

    @Output() changedVisibleDriverTransactionDetailEmit = new EventEmitter<boolean>();
    changedVisibleDriverTransactionDetail(increased: any) {
        this.changedVisibleDriverTransactionDetailEmit.emit(increased);
    }

    onAntiFraudActionCompleted(): void {
        this.changedVisibleDriverTransactionDetail(true);
    }

    public userWalletOperationType = UserWalletOperationTypeEnum;
    public menuItems: MenuItem[] = [{ label: '' }];

    constructor(private messageService: MessageService,
                private deliveryOrderService: DeliveryOrderService) {
    }

    ngOnInit(): void {
        this.orderId = this.transaction.OrderId;
        if (this.orderId) {
            this.getRiderOrderDetail();
        }

        switch (this.transaction.XpressUserWalletOperationTypeId) {
            case UserWalletOperationTypeEnum.CustomerTip:
            case UserWalletOperationTypeEnum.RiderTip:
                this.menuItems = [{ label: 'Driver Tip Details' }];
                break;
            case UserWalletOperationTypeEnum.RiderEarning:
                this.menuItems = [{ label: 'Job Earning Details' }];
                break;
            case UserWalletOperationTypeEnum.PayOut:
            case UserWalletOperationTypeEnum.PayOutPending:
            case UserWalletOperationTypeEnum.PayOutFee:
            case UserWalletOperationTypeEnum.PayOutRestore:
            case UserWalletOperationTypeEnum.PayOutFeeRestore:
                this.menuItems = [{ label: 'Cashout Details' }];
                break;
        }
    }

    cancel() {
        this.changedVisibleDriverTransactionDetail(false);
    }

    isCashout() {
        return this.transaction.XpressUserWalletOperationTypeId === UserWalletOperationTypeEnum.PayOut
         || this.transaction.XpressUserWalletOperationTypeId === UserWalletOperationTypeEnum.PayOutPending
         || this.transaction.XpressUserWalletOperationTypeId === UserWalletOperationTypeEnum.PayOutFee
         || this.transaction.XpressUserWalletOperationTypeId === UserWalletOperationTypeEnum.PayOutRestore
         || this.transaction.XpressUserWalletOperationTypeId === UserWalletOperationTypeEnum.PayOutFeeRestore;
    }

    public getRiderOrderDetail() {
        const dto = {
            OrderId: this.orderId,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.deliveryOrderService.getRiderDeliveryOrderDetail(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.riderOrderDetail = data;
                this.riderOrderDetail.Amount = `₱ ${this.riderOrderDetail.Amount.toFixed(2) }`;
                this.riderOrderDetail.InitialTotalFareAmount = `₱ ${this.riderOrderDetail.InitialTotalFareAmount.toFixed(2) }`;
                this.riderOrderDetail.TipAmount = `₱ ${this.riderOrderDetail.TipAmount.toFixed(2) }`;
                this.riderOrderDetail.BaseFare = `₱ ${this.riderOrderDetail.BaseFare.toFixed(2) }`;
                this.riderOrderDetail.DistanceFare = `₱ ${this.riderOrderDetail.DistanceFare.toFixed(2) }`;
                this.riderOrderDetail.TripDurationCharge = `₱ ${this.riderOrderDetail.TripDurationCharge.toFixed(2) }`;
                this.riderOrderDetail.SurgeCharges = `₱ ${this.riderOrderDetail.SurgeCharges.toFixed(2) }`;
                this.riderOrderDetail.CreatedAt = moment(this.riderOrderDetail.CreatedAt).format('D MM YYYY');
                this.riderOrderDetail.OrderRequestedDate = moment(this.riderOrderDetail.OrderRequested).format('D MM YYYY');
                this.riderOrderDetail.OrderAcceptedDate = (this.riderOrderDetail.OrderAccepted) ?
                    moment(this.riderOrderDetail.OrderAccepted).format('D MM YYYY') : '';
                this.riderOrderDetail.ArrivedToPickupTime = (this.riderOrderDetail.ArrivedToPickupTime)
                    ? moment(this.riderOrderDetail.ArrivedToPickupTime).format('hh:mm') : '';
                this.riderOrderDetail.PickupTime = (this.riderOrderDetail.PickupTime)
                    ? moment(this.riderOrderDetail.PickupTime).format('hh:mm') : '';
                this.riderOrderDetail.DroppedOffTime = (this.riderOrderDetail.DroppedOffTime) ?
                    moment(this.riderOrderDetail.DroppedOffTime).format('hh:mm') : '';
                this.riderOrderDetail.CompletedTime = (this.riderOrderDetail.CompletedTime) ?
                    moment(this.riderOrderDetail.CompletedTime).format('hh:mm') : '';
                this.riderOrderDetail.UserCreatedAt = moment(this.riderOrderDetail.UserCreatedAt).format('D MMM YYYY');
                this.riderOrderDetail.OrderAttempts.forEach((attempt: any) => {
                    attempt.CreatedAt = moment(attempt.CreatedAt).format('hh:mm:ss');
                });
                this.riderOrderDetail.PickupSurgeAmountText = (this.riderOrderDetail.PickupSurgeAmount > 0) ?
                    `₱${this.riderOrderDetail.PickupSurgeAmount}` : '-';
                this.riderOrderDetail.WaitingFeeAmountText = (this.riderOrderDetail.WaitingFeeAmount > 0) ?
                    `₱${this.riderOrderDetail.WaitingFeeAmount}` : '-';
                this.riderOrderDetail.OrderAcceptedTime = (this.riderOrderDetail.OrderAccepted) ? moment(this.riderOrderDetail.OrderAccepted).format('hh:mm') : '';
                this.riderOrderDetail.OrderChats.forEach((message: any) => {
                    message.CreatedAt = Utils.utcToLocaleString(message.CreatedAt);
                });
                this.riderOrderDetail.DropoffOrderTimes.forEach((item: any) => {
                    item.CreatedAtTime = (item.CreatedAt) ? moment(item.CreatedAt).format('hh:mm') : '';
                });
                this.riderOrderDetail.UserRating = this.riderOrderDetail.UserRating.toFixed(1);
                this.riderOrderDetail.TotalSpend = `₱ ${this.riderOrderDetail.TotalSpend.toFixed(2)}`;
            });

    }
}
